(function () {
  'use strict';

  /* @ngdoc object
   * @name dashboard
   * @description
   *
   */
  angular
    .module('dashboard', [
      'ui.router',
      'dashboard.pod',
      'dashboard.memberships',
      'dashboard.stats'
    ]);
}());
